export default "__VITE_ASSET__161c5e60__"